import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdnPipe } from './pipes/cdn.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [CdnPipe],
  exports: [CdnPipe],
})
export class CdnModule {}
